import { render, staticRenderFns } from "./QueryTags.vue?vue&type=template&id=2282a64a&scoped=true"
import script from "./QueryTags.vue?vue&type=script&lang=js"
export * from "./QueryTags.vue?vue&type=script&lang=js"
import style0 from "./QueryTags.vue?vue&type=style&index=0&id=2282a64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282a64a",
  null
  
)

export default component.exports